// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PriceRangeCriteria = require("./PriceRangeCriteria.bs.js");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql = require("../../../__generated__/PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.bs.js");

let convertFragment = PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PriceRangeCriteria__BuyerNeed(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(PriceRangeCriteriaBuyerNeed_buyerNeedV5_graphql.node, convertFragment, props.buyerNeed);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "price range",
    children: JsxRuntime.jsx(PriceRangeCriteria.make, {
      priceRange: buyerNeed.priceRange.fragmentRefs,
      priceType: "oneTime",
      size: props.size,
      className: props.className
    })
  });
}

let make = PriceRangeCriteria__BuyerNeed;

exports.Fragment = Fragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
